import { STANDARD_PHYS_DESCR_FIELDS } from './constants';

const TextPhysDescriptionFieldConfig = [...STANDARD_PHYS_DESCR_FIELDS];

export default TextPhysDescriptionFieldConfig;
